import React from "react";
import { SingleChoice, MultiChoice, Pairwise, ScaleQ } from "./inputs/Choice";
import { RankList, Allocate } from "./inputs/RankAllocate";
import { SliderQ, SlidersQ, TextQ } from "./inputs/Sliders";

export default function QuestionRenderer({ q, value, onChange }) {
  switch (q.type) {
    case "single":
    case "scenario":
      return <SingleChoice q={q} value={value} onChange={onChange} />;
    case "multi":
      return <MultiChoice q={q} value={value} onChange={onChange} />;
    case "rank":
      return <RankList q={q} value={value} onChange={onChange} />;
    case "allocate":
      return <Allocate q={q} value={value} onChange={onChange} />;
    case "slider":
      return <SliderQ q={q} value={value} onChange={onChange} />;
    case "sliders":
      return <SlidersQ q={q} value={value} onChange={onChange} />;
    case "scale":
      return <ScaleQ q={q} value={value} onChange={onChange} />;
    case "text":
      return <TextQ q={q} value={value} onChange={onChange} />;
    case "pairwise":
      return <Pairwise q={q} value={value} onChange={onChange} />;
    default:
      return <p className="st-muted">Unsupported question type</p>;
  }
}

export function isComplete(q, value) {
  if (value == null) return false;
  switch (q.type) {
    case "multi": return value.length === q.max;
    case "sliders": return Object.keys(value).length === q.items.length;
    case "pairwise": return Object.keys(value).length === q.pairs.length;
    case "text": return value.trim().length > 0;
    case "allocate": return Math.abs(Object.values(value).reduce((s, n) => s + (Number(n) || 0), 0) - q.total) < 0.5;
    default: return true;
  }
}
